import { STATUS_INFO } from "../config";

// Groups the bid/order states from ordr-flutter constants.dart into pill tones.
const SUCCESS = [3, 4, 5, 6, 7, 10, 16, 31, 32, 34];
const DANGER = [8, 11, 21, 22, 28, 30];
const WARNING = [19, 20, 23, 24, 25, 26];
const INFO = [9, 12, 13, 14, 15];

// Orders-page tab for each bidRequestState (fuel-order appConfig.bidRequestState).
const ORDER_BUCKETS = {
	bidRequest: [1, 2, 3, 4, 16], // awaiting bids / award / seller confirmation
	openOrder: [5, 9, 10, 11, 19, 20, 23, 24], // confirmed, delivery being scheduled, cancellation pending/rejected
	ordersInProgress: [12, 13, 14, 15, 25], // driver on the way
	pastOrder: [6, 7, 26, 27, 28, 29, 30, 31, 32, 33, 34], // delivered through settlement and order completed
	closedOrders: [8, 17, 18, 21, 22], // cancelled / withdrawn
};

export function orderBucket(state) {
	const s = Number(state);
	return Object.keys(ORDER_BUCKETS).find((key) => ORDER_BUCKETS[key].includes(s)) || null;
}

export function statusLabel(order) {
	return STATUS_INFO[order?.bidRequestState] || order?.bidRequestStateLabel || "-";
}

export function statusTone(state) {
	const s = Number(state);
	if (SUCCESS.includes(s)) return "success";
	if (DANGER.includes(s)) return "danger";
	if (WARNING.includes(s)) return "warning";
	if (INFO.includes(s)) return "info";
	return "";
}

export function orderNumber(order, fallbackId) {
	return order?.orderId || (order?._id || order?.id || fallbackId || "").slice(-6).toUpperCase();
}

// Same per-truck limits as ordr-flutter bid_request_screen (diesel/kerosene 9,800; gasoline grades 11,200).
export function maxOrderSize(product) {
	const value = String(product?.value || "").toLowerCase();
	const title = String(product?.Title || "").toLowerCase();
	if (value.includes("diesel") || value.includes("kerosene")) return 9800;
	if (value.includes("mid") || title.includes("premium") || title.includes("regular")) return 11200;
	return 10000;
}

// Mirrors fuel-order constantCollection.deliveryTiming (value -> Title); unknown values pass through.
const DELIVERY_WINDOWS = {
	"4-8": "4 - 8 AM",
	"8-12": "8 AM - 12 PM",
	"12-16": "12 - 4 PM",
	"16-20": "4 - 8 PM",
	"20-24": "8 PM - 12 AM",
	"0-4": "12 - 4 AM",
	"0-24": "Any available",
};
export const formatDeliveryWindow = (value) => (value ? DELIVERY_WINDOWS[String(value).trim()] || String(value) : "-");

export const formatGallons = (n) => (n || n === 0 ? `${Number(n).toLocaleString()} gal` : "-");
export const formatMoney = (n) =>
	n || n === 0 ? `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : "-";
